/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum CreateCreditRequestConflictType {
  PendingCreditRequest = 'pending_credit_request',
  UserNotFound = 'user_not_found',
  MissingRequiredComment = 'missing_required_comment'
}
